import React from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import AIControlSidebar from "../components/AIControlSidebar";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const AIPanelLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 80px)",
        backgroundColor: "#020617",
        overflowX: "hidden",
        position: "relative",
      }}
    >
      {/* Фиксированная панель слева */}
      <AIControlSidebar />

      {/* Основной контент, отступ управляется CSS-переменной */}
      <Box
        component="main"
        sx={{
          ml: "var(--pp-sidebar-offset, 104px)",  // когда панель свернута — будет 0
          background:
            "radial-gradient(circle at top, rgba(30,64,175,.35), transparent 55%), #020617",
          p: isMobile ? 1.25 : 3,
          minWidth: 0,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AIPanelLayout;

